<template>
  <CHeader with-subheader>
    <CToggler in-header class="d-lg-none" @click="$store.commit('toggleSidebarMobile')" />
    <CToggler in-header class="ml-3 d-md-down-none" @click="$store.commit('toggleSidebarDesktop')" />
    <CHeaderBrand class="mx-auto d-lg-none logo" to="/">
      <!--   <CIcon name="logo" height="48" alt="Logo"/> -->
      <!--   <b-img class="logo" src="/img/brand/logo_trans.png" height="48" alt="Logo"></b-img>
      <span class="logo-text c-sidebar-brand-full">Travel Places</span> -->

      <div class="logo-img">
        <b-img class src="/img/brand/logo_trans.png"></b-img>
      </div>

      <span class="logo-text c-sidebar-brand-full logo-normal brand">
        <div class="name">TRAVEL PLACES</div>
        <div class="highlight">TEAM TRAVEL SPECIALISTS</div>
      </span>
    </CHeaderBrand>
    <CHeaderNav class="d-md-down-none mr-auto">
      <!-- <CHeaderNavItem class="px-3">
        <CHeaderNavLink to="/dashboard">Dashboard</CHeaderNavLink>
      </CHeaderNavItem>
      <CHeaderNavItem class="px-3">
        <CHeaderNavLink to="/users" exact>Users</CHeaderNavLink>
      </CHeaderNavItem>
      <CHeaderNavItem class="px-3">
        <CHeaderNavLink to="/settings">Settings</CHeaderNavLink>
      </CHeaderNavItem>-->
    </CHeaderNav>
    <CHeaderNav>
      <CHeaderNavItem class="px-0">
        <b-button-group>
          <b-button @click="() => $store.commit('toggle', 'darkMode')" squared class="c-header-nav-btn" id="darkmode"
            :class="$store.state.darkMode
              ? 'active'
              : ''
              ">
            <i :class="$store.state.darkMode == true
              ? 'fa fa-moon-o text-primary active'
              : 'fa fa-moon-o text-secondary'
              "></i>
          </b-button>
          <b-button @click="() => $store.commit('toggle', 'darkMode')" squared class="c-header-nav-btn" id="lightmode"
            :class="$store.state.darkMode
              ? ''
              : 'active'
              ">
            <i :class="$store.state.darkMode == true
              ? 'fa fa-sun-o text-secondary'
              : 'fa fa-sun-o text-primary '
              "></i>
          </b-button>
          <b-tooltip target="lightmode" placement="bottom">Switch to light mode</b-tooltip>
          <b-tooltip target="darkmode" placement="bottom">Switch to dark mode</b-tooltip>


        </b-button-group>
        <b-button-group class="ml-1">
          <div class="badgecontainer">
            <b-button id="notifications" to="/notifications" squared class="c-header-nav-btn">
              <i class="fa fa-bell text-gray"></i>
              <b-badge variant="primary" v-if="$store.state.notifications.length > 0">
                {{ $store.state.notifications.length }}</b-badge>
            </b-button>
            <b-tooltip target="notifications" placement="bottom">Your active notifications</b-tooltip>
          </div>
        </b-button-group>
        <!-- <button
          @click="() => $store.commit('toggle', 'darkMode')"
          class="c-header-nav-btn"
        >
          <CIcon v-if="$store.state.darkMode" name="cil-sun" id="darkmode" />

          <CIcon v-else name="cil-moon" id="lightmode" />
          <b-tooltip
            v-if="$store.state.darkMode"
            target="darkmode"
            placement="bottom"
            >Switch to light mode</b-tooltip
          >
          <b-tooltip v-else target="lightmode" placement="bottom"
            >Switch to dark mode</b-tooltip
          >
        </button> -->
      </CHeaderNavItem>
      <!-- <TheHeaderDropdownNotif
        v-if="user.permissions.includes('/notifications')"
      /> -->
      <!--      <TheHeaderDropdownTasks />
      <TheHeaderDropdownMssgs />-->

      <!-- <CHeaderNavItem class="px-0 hidden-xs">
        <button
          in-header
          class="c-header-nav-btn"
          @click="$store.commit('toggle', 'asideShow')"
        >
          <CIcon size="lg" name="cil-settings" class="mr-2" />
        </button>
      </CHeaderNavItem> -->
      <TheHeaderDropdownAccnt />
    </CHeaderNav>

    <!-- <CSubheader class="px-3">
      <CBreadcrumbRouter class="border-0 mb-0" />
    </CSubheader>-->
  </CHeader>
</template>

<script>
import { mapGetters } from "vuex";

import TheHeaderDropdownAccnt from "./TheHeaderDropdownAccnt";
import TheHeaderDropdownNotif from "./TheHeaderDropdownNotif";
import TheHeaderDropdownTasks from "./TheHeaderDropdownTasks";
import TheHeaderDropdownMssgs from "./TheHeaderDropdownMssgs";

export default {
  name: "TheHeader",
  components: {
    TheHeaderDropdownAccnt,
    TheHeaderDropdownNotif,
    TheHeaderDropdownTasks,
    TheHeaderDropdownMssgs,
  },
  computed: {
    ...mapGetters(["user"]),
  },
};
</script>
